"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.extractArticlesFromComponents = extractArticlesFromComponents;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function extractArticlesFromComponents(components) {
  return components.filter(function (c) {
    return c.type === 'article';
  }).flatMap(function (c) {
    return c.articles;
  });
}

function describeSignals(components) {
  var signals = [];
  if (components.some(function (c) {
    return c.type === 'text';
  })) signals.push('Natural-language answer');
  if (components.some(function (c) {
    return c.type === 'article';
  })) signals.push('Knowledge base / community match');
  if (components.some(function (c) {
    return c.type === 'button';
  })) signals.push('Clarification options');
  if (components.some(function (c) {
    return c.type === 'form';
  })) signals.push('Information request');

  if (components.some(function (c) {
    return c.type === 'zendesk_handoff' || c.type === 'salesforce_handoff' || c.type === 'zendesk_ticket_creation';
  })) {
    signals.push('Escalation to human agent');
  }

  return signals;
}

var ReasoningTrace = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ReasoningTrace, _PureComponent);

  var _super = _createSuper(ReasoningTrace);

  function ReasoningTrace() {
    var _this;

    (0, _classCallCheck2.default)(this, ReasoningTrace);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      expanded: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggle", function () {
      return _this.setState(function (prev) {
        return {
          expanded: !prev.expanded
        };
      });
    });
    return _this;
  }

  (0, _createClass2.default)(ReasoningTrace, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          components = _this$props.components,
          responseTimeMs = _this$props.responseTimeMs;
      var expanded = this.state.expanded;
      var articles = extractArticlesFromComponents(components);
      var sourceTypes = Array.from(new Set(articles.map(function (a) {
        return a.source_type;
      }).filter(Boolean)));
      var signals = describeSignals(components);
      return (0, _preact.h)("div", {
        className: "forethought-agent__trace"
      }, (0, _preact.h)("button", {
        type: "button",
        className: "forethought-agent__trace-toggle",
        "aria-expanded": expanded,
        onClick: this.toggle
      }, expanded ? '▾' : '▸', " How I got here"), expanded && (0, _preact.h)("div", {
        className: "forethought-agent__trace-body"
      }, (0, _preact.h)("div", {
        className: "forethought-agent__trace-row"
      }, (0, _preact.h)("span", {
        className: "forethought-agent__trace-label"
      }, "Sources considered:"), (0, _preact.h)("span", null, articles.length)), sourceTypes.length > 0 && (0, _preact.h)("div", {
        className: "forethought-agent__trace-row"
      }, (0, _preact.h)("span", {
        className: "forethought-agent__trace-label"
      }, "Source types:"), (0, _preact.h)("span", null, sourceTypes.join(', '))), signals.length > 0 && (0, _preact.h)("div", {
        className: "forethought-agent__trace-row"
      }, (0, _preact.h)("span", {
        className: "forethought-agent__trace-label"
      }, "Signals:"), (0, _preact.h)("span", null, signals.join(', '))), responseTimeMs !== undefined && (0, _preact.h)("div", {
        className: "forethought-agent__trace-row"
      }, (0, _preact.h)("span", {
        className: "forethought-agent__trace-label"
      }, "Response time:"), (0, _preact.h)("span", null, (responseTimeMs / 1000).toFixed(2), "s")), articles.length > 0 && (0, _preact.h)("ul", {
        className: "forethought-agent__trace-articles"
      }, articles.map(function (a) {
        return (0, _preact.h)("li", {
          key: a.document_id || a.link
        }, (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)(a.link),
          target: "_blank",
          rel: "noreferrer"
        }, a.title), (0, _preact.h)("span", {
          className: "forethought-agent__trace-articles-type"
        }, " \xB7 ", a.source_type));
      }))));
    }
  }]);
  return ReasoningTrace;
}(_preactCompat.PureComponent);

var _default = ReasoningTrace;
exports.default = _default;